import { AuthorizationCodeTokenClient, OidcUrlHelper } from '@ori/auth';
import type { AppConfiguration } from '@ori/favorites-context';
import { parseSpaConfig } from '@ori/favorites-utils';

import { App } from './App';
import { IDENTITY_CLIENT_ID } from './constants';

export const render = async (rootElement: HTMLElement): Promise<boolean> => {
  if (!rootElement.dataset.config) {
    // if there is no config in the dataset then we will not even try to do anything else
    return false;
  }
  const config = parseSpaConfig(rootElement.dataset.config, ['customerId', 'globalApiUrl', 'tenant']);
  // extract token from URL; only on dev machine, not needed elsewhere
  if (process.env.NODE_ENV !== 'production') {
    const searchParams = new URLSearchParams(window.location.hash.split('?')[1]);
    if (searchParams.has('state')) {
      const oidcUrlHelper = new OidcUrlHelper();
      const tokenClient = new AuthorizationCodeTokenClient({
        clientId: IDENTITY_CLIENT_ID,
        identityUrl: config.identityUrl ?? '',
      });
      oidcUrlHelper.storeAuthCodeFromParams(searchParams);
      await tokenClient.initializeTokenFromAuthorizationCode();
      oidcUrlHelper.handleRedirectAfterLogin();
    }
  }
  // Actual configuration that app will use
  const configuration: AppConfiguration = {
    currentLanguage: config.currentLanguage ?? '',
    customerId: config.customerId,
    globalApiUrl: config.globalApiUrl,
    graphqlUrl: config.graphqlUrl ?? '',
    identityUrl: config.identityUrl ?? '',
    onlineBaseUrl: config.onlineBaseUrl ?? window.location.origin,
    staticApiUrl: config.staticApiUrl ?? '',
    tenant: config.tenant,
  };
  const { createRoot } = await import('react-dom/client');
  createRoot(rootElement).render(<App configuration={configuration} />);

  return true;
};
